import { render, staticRenderFns } from "./PricingEdit.vue?vue&type=template&id=11908315&scoped=true"
import script from "./PricingEdit.vue?vue&type=script&lang=js"
export * from "./PricingEdit.vue?vue&type=script&lang=js"
import style0 from "./PricingEdit.vue?vue&type=style&index=0&id=11908315&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11908315",
  null
  
)

export default component.exports